window.addEventListener("load", () => {
  var states = document.getElementById("viewMoreStates");
  var cities = document.getElementById("viewMoreCities");
  var assisted = document.getElementById("viewMoreAssistedLiving");
  var content = document.getElementById("viewMoreContent");
  
  // Hides additional footer text on all pages except the frontpage
  if (!document.querySelector(".front-page")) {
    document.querySelector(".footer-text").style.display = "none";
  }

  // Footer links
  document.getElementById("btnViewMoreStates").addEventListener("click", () => {
    states.style.display = "inline-block";
    cities.style.display = "none";
    assisted.style.display = "none";
    content.style.display = "none";
  });
  document.getElementById("btnViewMoreCities").addEventListener("click", () => {
    cities.style.display = "inline-block";
    states.style.display = "none";
    assisted.style.display = "none";
    content.style.display = "none";
  });
  document.getElementById("btnViewMoreAssistedLiving").addEventListener("click", () => {
    assisted.style.display = "inline-block";
    states.style.display = "none";
    cities.style.display = "none";
    content.style.display = "none";
  });
  document.getElementById("btnViewMoreContent").addEventListener("click", () => {
    content.style.display = "inline-block";
    states.style.display = "none";
    cities.style.display = "none";
    assisted.style.display = "none";
  });
  Array.from(document.querySelectorAll(".more-less")).forEach(button => {
    button.addEventListener("click", () => {});
  });
  Array.from(document.querySelectorAll(".view-more-close")).forEach(button => {
    button.addEventListener("click", () => {
      states.style.display = "none";
      cities.style.display = "none";
      content.style.display = "none";
      assisted.style.display = "none";
    });
  });

  // Added js code regarding task #7
    var showMore = document.getElementById("HPMore");
    var showLess = document.getElementById("HPLess");
    var showContent = document.getElementById("ShowMore");
    if (document.querySelector(".front-page")) {
        document.getElementById("HPMore").addEventListener("click", () => {
            showContent.style.display = "inline-block";
            showMore.style.display = "none";
            showLess.style.display = "inline-block";
        });
        document.getElementById("HPLess").addEventListener("click", () => {
            showContent.style.display = "none";
            showMore.style.display = "inline-block";
            showLess.style.display = "none";
        });
    }
});
